import react, { useMemo, useEffect } from "react";
import { authenticateGuideUser } from "./utils";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";

const googlePlayImage = "./GetItOnGooglePlay_Badge_Web_color_English.png"

const GuideLogin = (props) => {

    const [email, setEmail] = react.useState("");
    const [password, setPassword] = react.useState("");
    const [sentReset, setSentReset] = react.useState(false);
    const [isResetting, setIsResetting] = react.useState(false);
    const [resetMessage, setResetMessage] = react.useState("");
    const [editingPassword, setEditingPassword] = react.useState(false);
    const [showingPassword, setShowingPassword] = react.useState(false);

    function useQuery() {
        const { search } = useLocation();

        return useMemo(() => new URLSearchParams(search), [search]);
    }

    let query = useQuery();
    
    useEffect(() => {
        if(query.get("reset") === "success") {
            setResetMessage("Your password has been reset successfully. Please log in with your new password.");
        }
    }, [query]);


    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const handlePasswordChange = (e) => {
        setEditingPassword(true);
        if(!e.target.value) {
            setEditingPassword(false);
        }
        setPassword(e.target.value);
    }

    useEffect(() => {
        const authenticationData = authenticateGuideUser();
        authenticationData.then(data => {
            if(data && data.isLoggedIn) {
                window.location.href = "/phone"; // Redirect to guide dashboard
            }
        });
    }, []);

    useEffect(() => {
        //listen for enter key to submit the form
        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                if(isResetting) {
                    handleResetPassword();
                } else {
                    handleSubmit(e);
                }
            }
        }
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }
    }, [email, password, isResetting]); // Add dependencies so it updates when these values change

    const handleSubmit = (e) => {
        e.preventDefault();
        
        fetch(`${process.env.REACT_APP_API_URL}/guide/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        }   )
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Handle successful login
                console.log("Guide logged in successfully");
                const { token, token_expiry } = data;
                window.localStorage.setItem('guideToken', token);
                window.localStorage.setItem('guideTokenExpiry', token_expiry);
                if(props.fromExpiredTokenModal) {
                    props.closeExpiredTokenModal();
                    return;
                }
                window.location.href = "/phone"; // Redirect to guide dashboard
            } else {
                // Handle login error
                console.error("Guide login failed");
                alert("Login failed. Please check your credentials and try again.");
            }
        })
        .catch(error => {
            console.error("Error occurred during guide login:", error);
        });
    }
    const handleResetPassword = () => {
        if(!email) {
            setIsResetting(true);
            return;
        }
        fetch(`${process.env.REACT_APP_API_URL}/guide/reset-password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                setSentReset(true);
            } else {
                alert("Failed to send password reset instructions. Please try again later.");
            }
        })
        .catch(error => {
            console.error("Error occurred during password reset:", error);
            alert("An error occurred. Please try again later.");
        });
    }

    const setPasswordHidden = () => {
        setShowingPassword(!showingPassword);
    }
    return (
        <>
        <section className="main-body-section" style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <div className="login-container" style={{ textAlign: "center", marginTop: "50px", maxWidth: "95vw" }}>
                <div>
                    <img
                        onClick={() => window.open("https://theboggler.com", "_self")}
                        src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.png"
                        alt="Boggler Logo"
                        className="boggler-logo"
                        loading="lazy"
                        style={{ borderRadius: 8, cursor: 'pointer' }}
                    />
                    <h2>Boggler Guide Login</h2>
                </div>
                <div>
                {!sentReset && (
                    <div className="login-form">
                        {resetMessage && <p style={{ color: "green" }}>{resetMessage}</p>}
                        <section style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <div style={{display: "flex", flexDirection: "column", alignItems: "start"}}>
                                <input onChange={handleEmailChange} type="email" name="email" placeholder="Enter your email" style={{fontSize: "24px", padding: "10px", width: "300px", textAlign: "center"}} /><br />
                                {!isResetting && <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}><input onChange={handlePasswordChange} type={showingPassword ? "text" : "password"} name="password" placeholder="Enter your password" style={{fontSize: "24px", padding: "10px", width: "300px", textAlign: "center", marginTop: "10px"}} />{editingPassword && <span onClick={setPasswordHidden} style={{marginLeft: "10px"}}>🧿</span>}<br /></div>}
                            </div>
                            <div style={{display: "flex", justifyContent: "center", width: "100%"}}>
                                <button onClick={isResetting ? handleResetPassword : handleSubmit} style={{backgroundColor: "#fe9628", color: "#fff", marginTop: "20px", padding: "10px 20px", fontSize: "24px", cursor: "pointer"}}>
                                    {isResetting ? "Reset Password" : "Login"}
                                </button>
                            </div>
                        </section>
                        <div style={{marginTop: "20px"}}>
                            <button onClick={!isResetting ? handleResetPassword : () => setIsResetting(false)} style={{backgroundColor: "#24afc2", color: "#fff", padding: "10px 20px", fontSize: "18px", cursor: "pointer"}}>{!isResetting ? "Forgot Password?" : "Back to Login"}</button>
                        </div>
                        <div style={{marginTop: "20px", fontSize: "14px", color: "#666", maxWidth: "85vw", margin: "20px auto"}}>
                            <p>Don't have an account? Please visit the signup page to apply.</p>
                            <button onClick={() => window.open("/signup/influencer", "_self")} style={{backgroundColor: "#28a745", color: "#fff", padding: "10px 20px", fontSize: "18px", cursor: "pointer"}}>Go to Signup</button>
                        </div>
                    </div>
                )}
                {sentReset && (
                    <div style={{marginTop: "20px", fontSize: "18px", color: "#28a745"}}>
                        <p style={{margin: "10px auto", width: "75%"}}>Password reset instructions have been sent to your email.</p>
                        <button onClick={() => setSentReset(false)} style={{backgroundColor: "#fe9628", color: "#fff", padding: "10px 20px", fontSize: "18px", cursor: "pointer"}}>Back to Login</button>
                    </div>
                )}
                </div>
            </div>
        </section>
        <Footer />
        </>
    );
}

export default GuideLogin;